import React from 'react'
import Html from '../Html'
import styles from './styles.module.css'

const SearchResultItem = ({ title, children }) => {
  return (
    <li className={styles.searchResultItem}>
      <Html as="span" className={styles.searchResultItemTitle}>
        {title}
      </Html>

      {children}
    </li>
  )
}

export default SearchResultItem
